import React, { useState , useEffect} from "react";
import { Helmet } from "react-helmet";
import { useTranslation } from "react-i18next";
import { Translation } from 'react-i18next';
import Image from "../../../components/image";
import { asset } from "../../../helpers/dom.helper";
import styles from '../visitorControl/visitorControl.module.scss';

export default function VisitorControl() {

  const { t, i18n } = useTranslation(['translation', 'visitorControl'])
  const [activeIndex, setActiveIndex] = useState(0)
  
  useEffect(() => {
    if (i18n.language === 'th') {
      setActiveIndex(0);
    } else if (i18n.language === 'en') {
      setActiveIndex(1);
    }
  }, [i18n.language]);

  return (    
    <Translation ns={['translation', 'pricing']}>
        {t => (
            <>
                <Helmet>
                    <title>{t("visitorControl:Package fee for supplementary accounting services and audit services")}</title>
                    <meta name="description" content={t("visitorControl:Package fee for supplementary accounting services and audit services")} />
                    <meta name="keywords" content={t("visitorControl:Package fee for supplementary accounting services and audit services")} />
                    <link rel="canonical" href="https://silverman.app/price-and-package/account-service" />              
                </Helmet>

                <div className={styles.visitorControl}>
                    <div className="text-address text-sm-center p-4">
                        <h1 className="h3">{t("pricing:Choose the package that is right for you.")}</h1>
                        <p className="h5">{t("pricing:Price / Property / 1 Month")}</p>                      
                    </div>

                    <div>
                    <div className="row pb-5">
                        <div className="col-12 col-sm-8 offset-sm-2">
                        {
                            activeIndex === 0 &&  <Image src={asset('/images/pricing/vatPosterTH.webp')} alt="vatPosterTH" className="d-block w-100 h-auto shadow" />
                        }
                        {
                            activeIndex === 1 &&  <Image src={asset('/images/pricing/vatPosterEN.webp')} alt="vatPosterEN" className="d-block w-100 h-auto shadow" />
                        }
                        
                        </div>
                    </div>
                    </div>
                </div>
            </>
        )}
    </Translation>
  )

}